import { useCategoryElementProperties } from '@client/hooks/use-element-properties.hooks';
import { isElementCategoryID } from '@shared/helpers/element-category.helpers';
import { IElement } from '@shared/models/project.model';
import { ElementPropertiesForm } from './ElementPropertiesForm';

export const ElementCoreSettingsProperties: React.FC<{
  element: IElement;
  excludeProperties?: string[];
}> = ({ element, excludeProperties = [] }) => {
  const { category_id } = element;
  const categoryElementProperties = useCategoryElementProperties(
    element,
    excludeProperties,
  );

  const isValidCategory = isElementCategoryID(category_id);

  return (
    isValidCategory && (
      <ElementPropertiesForm
        element={element}
        properties={categoryElementProperties}
      />
    )
  );
};
